console.log("Collections Materials Only Loaded x 1");

let toggleSizeCon = document.querySelector("#toggle-size");
let toggleSizeBtn = toggleSizeCon.querySelector("a");

let collectionProducts = document.querySelectorAll(".collection-con li");

if (toggleSizeCon) {
  toggleSizeBtn.addEventListener("click", function (event) {
    event.preventDefault();
    let currentSize = toggleSizeBtn.innerHTML;

    if (currentSize == "Small") {
      //currentSize = 'Large';
      toggleSizeBtn.innerHTML = "Large";
    } else {
      toggleSizeBtn.innerHTML = "Small";
    }

    collectionProducts.forEach(function (item, i) {
      item.classList.toggle("enlarge");
    });
  });
}
//
//
//Filters
//
//

//Open Filter
let filtersBtn = document.querySelector("#filters-btn");
filtersBtn.addEventListener("click", function (event) {
  event.preventDefault();
  document.querySelector("#filters-pop").classList.add("open");
  activateOverlay();
});

//Close Filter
let closeFilters = document.querySelector("#close-filters");
closeFilters.addEventListener("click", function (event) {
  event.preventDefault();
  document.querySelector("#filters-pop").classList.remove("open");
  killOverlay();
});

//Clear Filters
let clearfiltersBtn = document.querySelector("#clear-filters");
clearfiltersBtn.addEventListener("click", function (event) {
  event.preventDefault();
  let radioFilters = document.querySelectorAll("#filters-pop input");
  radioFilters.forEach(function (item) {
    item.checked = false;
  });
});

let applyfiltersBtn = document.querySelector("#apply-filters");
let getSortOptions = document.querySelectorAll(".sort-options li input");
let getFilterCollection = document.querySelectorAll(
  ".filter-category li input",
);
let getFilterMateriality = document.querySelectorAll(
  ".filter-materiality li input",
);

//Global Filters
let getSortParam = function () {
  let sortPath = "";
  getSortOptions.forEach(function (item, i) {
    if (item.checked) {
      sortPath = item.value;
    }
  });
  return sortPath;
};

let getMatParam = function () {
  let matParam = "";
  getFilterMateriality.forEach(function (item, i) {
    if (item.checked) {
      matParam = item.value;
    }
  });
  return matParam;
};

let buildLink = function (sortParam, matParam) {
  let sortPath = sortParam;
  let sortMat = matParam;
  let currentLocation = window.location.href;
  let baseUrl = document.location.origin;
  let baseCollection = "";

  if (currentLocation.includes("view-all-earrings")) {
    baseCollection = "view-all-earrings";
  } else if (currentLocation.includes("hoop-earrings")) {
    baseCollection = "hoop-earrings";
  } else if (currentLocation.includes("drop-earrings")) {
    baseCollection = "drop-earrings";
  } else if (currentLocation.includes("stud-earrings")) {
    baseCollection = "stud-earrings";
  } else if (currentLocation.includes("pearl-earings")) {
    baseCollection = "pearl-earings";
  } else if (currentLocation.includes("view-all-necklaces")) {
    baseCollection = "view-all-necklaces";
  } else if (currentLocation.includes("chain-necklaces")) {
    baseCollection = "chain-necklaces";
  } else if (currentLocation.includes("collar-necklaces")) {
    baseCollection = "collar-necklaces";
  } else if (currentLocation.includes("pendant-necklaces")) {
    baseCollection = "pendant-necklaces";
  } else if (currentLocation.includes("pearl-necklaces")) {
    baseCollection = "pearl-necklaces";
  } else if (currentLocation.includes("bracelets")) {
    baseCollection = "bracelets";
  } else if (currentLocation.includes("rings")) {
    baseCollection = "rings";
  } else if (currentLocation.includes("anklets")) {
    baseCollection = "anklets";
  } else if (currentLocation.includes("baby")) {
    baseCollection = "baby";
  } else if (currentLocation.includes("novelty")) {
    baseCollection = "novelty";
  } else if (currentLocation.includes("new-collection")) {
    baseCollection = "new-collection";
  } else if (currentLocation.includes("in-stock")) {
    baseCollection = "in-stock";
  } else if (currentLocation.includes("best-sellers")) {
    baseCollection = "best-sellers";
  } else if (currentLocation.includes("fine-collection")) {
    baseCollection = "fine-collection";
  } else if (currentLocation.includes("unisex-jewelry")) {
    baseCollection = "unisex-jewelry";
  } else if (currentLocation.includes("art-jewelry")) {
    baseCollection = "art-jewelry";
  } else if (currentLocation.includes("18k-gold")) {
    baseCollection = "18k-gold";
  } else if (currentLocation.includes("/pearls")) {
    baseCollection = "pearls";
  } else if (currentLocation.includes("/lapis")) {
    baseCollection = "lapis";
  } else if (currentLocation.includes("/onyx")) {
    baseCollection = "onyx";
  } else if (currentLocation.includes("/hair-collection")) {
    baseCollection = "hair-collection";
  } else if (currentLocation.includes("/new-collection")) {
    baseCollection = "new-collection";
  } else if (currentLocation.includes("/sale")) {
    baseCollection = "sale";
  }

  let firstStage = "";
  let secondStage = "";

  //First Stage
  firstStage = baseUrl + "/collections/" + baseCollection;

  //Second Stage
  if (sortMat == "") {
    secondStage = firstStage;
  } else {
    secondStage = firstStage + "/" + sortMat;
  }

  //Third Stagef
  let thirdStage = secondStage + "/" + sortPath;

  window.location.assign(thirdStage);
  //console.log(thirdStage);
};

applyfiltersBtn.addEventListener("click", function (event) {
  event.preventDefault();
  let mySort = getSortParam();
  //let myColl = getCollectionParam();
  let myMat = getMatParam();

  buildLink(mySort, myMat);
});

window.addEventListener("load", function () {
  let currentLocation = window.location.href;
  //console.log(slashCount);

  let sortStatus = document.querySelector("#sort-status");
  getSortOptions.forEach(function (item, i) {
    if (currentLocation.includes(item.value)) {
      item.checked = true;
      //console.log(item.value + " is the move");
    }

    if (item.checked) {
      let defSort = item.value;

      switch (defSort) {
        case "?sort_by=manual":
          sortStatus.innerHTML = "Featured";
          break;
        case "?sort_by=created-descending":
          sortStatus.innerHTML = "Newest";
          break;
        case "?sort_by=price-ascending":
          sortStatus.innerHTML = "Ascending Price";
          break;
        case "?sort_by=price-descending":
          sortStatus.innerHTML = "Descending Price";
          break;
        default:
          sortStatus.innerHTML = "Featured";
      }
    }
  });

  getFilterMateriality.forEach(function (item, i) {
    if (currentLocation.includes(item.value)) {
      item.checked = true;
      //console.log(item.value + " is the move");
    }
  });
});
